import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { OAuthService } from "angular-oauth2-oidc";
import { GS1LoadingService } from "@gs1france/gs1-components-library";
import { StorageService } from "../../services/storage/storage.service";
import { C1UserInfo } from "src/app/models/c1UserInfo.model";
import { ContactService } from "../../services/contact/contact.service";
import { ContactInfo } from "src/app/models/contact.model";
import { GLNTypes } from "src/app/models/gln.model";
 
@Component({
  selector: '',
 template: `
    <cgu-dialog *ngIf="showCGU" (close)="closeCGU()"></cgu-dialog>
    <nonpayer-dialog *ngIf="showNonPayer"></nonpayer-dialog>
    <gln-popin *ngIf="showGlnPopin"></gln-popin>

  `
})
export class ConnectedPageComponent implements OnInit {
  showCGU = false;
  c1User?: C1UserInfo;
  showNonPayer = false;
  contact: ContactInfo;
  showGlnPopin = false;

  constructor(private router: Router, private oAuthService: OAuthService, private loadingService : GS1LoadingService, private storageService: StorageService,private _contact :ContactService ) {}

  async ngOnInit(): Promise<void> {
    this.loadingService.startLoading('connexion');
    if (this.oAuthService.hasValidAccessToken()) {
      const loginUserDate = await this._contact.loginuser();
      this.oAuthService.loadUserProfile().then((value: any) => {
        this.c1User = value.info as C1UserInfo;
       if(this.c1User && !this.c1User.company_id)
       {
        this.oAuthService.initImplicitFlow();
       }
      });
      this.oAuthService.setupAutomaticSilentRefresh();
      this.setupApplication();
    } else {
      this.oAuthService.customQueryParams={};
      this.oAuthService.initImplicitFlow();

    }
  }

  /**
   * Sets up the application by loading the contact.
   * @returns None
   */
  async setupApplication() {
  this.contact = await this.storageService.getContactInfo();
  this.loadingService.stopLoading('connexion');

  if (!this.contact.cguAcceptanceDate) {
    this.showCGU = true;
  } else if (this.contact.isNonPayer) {
    this.showNonPayer = true;
  } else {
     const glns = await this.storageService.getGLNs();

    const isAdmin = await this.storageService.isAdmin();

        const hasEmpty =  glns.some(gln => this.isEmptyGlnType(gln.glnType));
    if (hasEmpty && isAdmin) {
      this.showGlnPopin = true;
    } else {
      this.router.navigateByUrl('/mes-gln');
    }
  }
}
closeGlnPopin() {
  this.router.navigateByUrl('/mes-gln');
}
private isEmptyGlnType(glnType?: GLNTypes): boolean {
  if (!glnType) return true;  
  return Object.values(glnType).every(v => v === false);
}
  closeCGU() {
    if(this.contact.isNonPayer) {
      this.showNonPayer = true;
    }
    else {
     this.router.navigateByUrl('/mes-gln');
    }
  }
}
